import { getEnv } from "../../../utils/env"
import axios from "axios"
import { firebaseauth } from "../../mp-database/firebaseConfig"

let prefix = ""
const env = getEnv("PROJECT_ID")

if (env === "mp-ready-staging") {
  prefix = "STAGE"
}
if (env === "mp-ready-pre-production") {
  prefix = "PRE_PROD"
}
if (env === "mp-ready-production") {
  prefix = "PROD"
}

const baseURL = getEnv(`API_BASE_URL_${prefix}`)

// Pentest finding #2: take the ID token from the Firebase SDK on each request
// (it refreshes it as needed) instead of from localStorage.
const getAuthToken = async () => {
  const user = firebaseauth.currentUser
  return user ? user.getIdToken() : ""
}

let instance = axios.create({
  baseURL: baseURL,
  timeout: 90000, // 90 secs
  headers: {
    "Content-Type": "application/json"
  }
})

const interceptorRequestConfig = async config => {
  const authToken = await getAuthToken()
  if (authToken) {
    config.headers.Authorization = authToken
  }
  return config
}

instance.interceptors.request.use(interceptorRequestConfig, err => {
  return Promise.reject(err)
})

instance.interceptors.response.use(
  config => {
    return config
  },
  err => {
    // logout here if 401 status in response
    return Promise.reject(err)
  }
)

// formdata instance for file uploades etc
let fdInstance = axios.create({
  baseURL: baseURL,
  timeout: 90000, // 90 secs
  headers: {
    "Content-Type": "multipart/form-data"
  }
})

fdInstance.interceptors.request.use(interceptorRequestConfig, err => {
  return Promise.reject(err)
})

export default instance

export const axiosPublic = axios

export const formDataInstance = fdInstance
